var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.963379H513V342.956H0V0.963379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 238.873H513V342.956H0V238.873Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.963379H513V105.683H0V0.963379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 126.749H513V216.58H0V126.749Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.966L0 342.961V0.95752L256.5 171.966Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3205 125.056L94.1922 154.18L128.343 143.329L107.094 172.18L127.965 201.306L93.9597 190.013L72.7103 218.863L72.9448 183.031L38.9385 171.736L73.088 160.885L73.3205 125.056Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.959473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs);
export default __webpack_public_path__ + "static/media/SS.28c2dc24ec08329aaec63a947e3a9bdb.svg";
export { ForwardRef as ReactComponent };